import React, { Component } from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import Header from "./Header"
import Page from "./Page"
import Footer from "./Footer"
import Banner from "./Banner"

import "./Layout.scss"

class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navIsOpen: false,
      hideAnnouncement: true
    }
    this.openMenu = this.openMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
  }

  openMenu() {
    this.setState({
      ...this.state,
      navIsOpen: true,
    })
  }

  closeMenu() {
    this.setState({
      ...this.state,
      navIsOpen: false,
    })
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener("resize", this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions)
  }

  updateWindowDimensions() {
    this.setState({
      ...this.state,
      isMobile: window.innerWidth < 667,
    })
  }

  render() {
    const { location, children, hideHeaderFooter, darkMode, ...rest } =
      this.props

    if (hideHeaderFooter) {
      return (
        <div
          className={`App ${this.state.hideAnnouncement ? "" : "-has-announcement"} ${
            location.pathname === "/"
              ? "-home"
              : "-" + location.pathname.replace(/\//g, "")
          }`}
        >
          <Page {...rest} location={location}>
            {children}
            <p className="no-footer-return-link">
              <a href="https://ionq.com">return to main IonQ site ↫</a>
            </p>
          </Page>
        </div>
      )
    }

    return (
      <>
        <div
          className={`App ${this.state.hideAnnouncement ? "" : "-has-announcement"} ${
            location.pathname === "/"
              ? "-home"
              : "-" + location.pathname.replace(/\//g, "")
          }`}
        >
          <Header
            isMobile={this.state.isMobile}
            location={location}
            openMenu={this.openMenu}
            closeMenu={this.closeMenu}
            isOpen={this.state.navIsOpen}
            darkMode={darkMode}
          />
          <div
            className={`off-canvas-wrapper ${
              this.state.navIsOpen ? "-menu-open" : ""
            }`}
          >
            <Banner 
              hidden={this.state.hideAnnouncement}
              toggleAnnouncement={(value) => {
                this.setState({
                  ...this.state,
                  hideAnnouncement: value
                })
              }}
            />
            <Page {...rest} location={location}>
              {children}
            </Page>
          </div>
          <Footer location={location} />
          {/*cookie consent tag*/}
          <script
            async
            src="https://cmp.osano.com/16Bj8cT3ZS59228OC/c19db322-b217-46d0-8546-d226ff7a71ea/osano.js"
          ></script>
        </div>
      </>
    )
  }
}

Layout.propTypes = {
  className: PropTypes.string.isRequired,
  id: PropTypes.string,
  title: PropTypes.string,
  location: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
}

export default Layout
